import React, { ChangeEvent, ReactNode } from "react";
import { useField } from "formik";
import Input from "../Input";

interface FormInputProps {
  label?: string | ReactNode;
  name: string;
  placeholder?: string;
  id?: string;
  type?: string;
  labelClassName?: string;
  className?: string;
  error?: string;
  required?: boolean;
  handleChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  customElement?: React.ReactNode;
  disabled?: boolean;
  maxLength?: number;
  [key: string]: any;
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  name,
  placeholder = "",
  id = "",
  type = "text",
  labelClassName,
  className = "",
  error,
  required,
  handleChange,
  customElement = null,
  disabled = false,
  maxLength,
  ...props
}) => {
  const [field, meta, helpers] = useField(name);

  const onChange = (value: string | boolean) => {
    if (typeof value === "string" && maxLength && value.length > maxLength) {
      return;
    }
    helpers.setValue(value);
  };

  return (
    <Input
      {...props}
      label={label}
      labelClassName={labelClassName}
      type={type}
      name={name}
      placeholder={
        placeholder.charAt(0).toUpperCase() + placeholder.slice(1).toLowerCase()
      }
      id={id}
      className={`${className} ${error || (meta.touched && meta.error) ? "error border-danger" : ""}`}
      value={field.value}
      checked={field.value ?? false}
      error={error || (meta.touched ? meta.error : "")}
      required={required}
      onChange={(e) => {
        if (type === "checkbox") {
          onChange(e.target.checked);
          if (handleChange && typeof handleChange === "function") {
            handleChange(e);
          }
        } else {
          onChange(e.target.value);
          if (handleChange && typeof handleChange === "function") {
            handleChange(e);
          }
        }
      }}
      customElement={customElement}
      disabled={disabled}
    />
  );
};

export default FormInput;
